import React from "react";
import ImgSessaoCinema from "../../../../assets/images/foto-destaque-sessao-cinema.jpg";
import ImgSessaoCinema1 from "../../../../assets/images/foto-galeria-sessao-cinema-1.jpg";
import ImgSessaoCinema2 from "../../../../assets/images/foto-galeria-sessao-cinema-2.jpg";
import ImgSessaoCinema3 from "../../../../assets/images/foto-galeria-sessao-cinema-3.jpg";
import Galery from "../../../../components/Galery";

const galeryImgs = [
  { src: ImgSessaoCinema1, alt: "Sessão de Cinema 1" },
  { src: ImgSessaoCinema2, alt: "Sessão de Cinema 2" },
  { src: ImgSessaoCinema3, alt: "Sessão de Cinema 3" },
];

const SessaoCinema = () => {
  return (
    <div className="detalhes-iniciativa">
      <main className="banner-detalhes-iniciativa-mobile bg-sessao-cinema" />

      <section className="detalhes-iniciativa-content container">
        <div className="row gutters">
          <div className="col grid_6">
            <h2 className="subtitulo-verde">Sessão de cinema</h2>
            <p>
              Um dos modos de expressão cultural, o cinema é capaz de despertar
              ideias, sentimentos e percepções através de suas histórias. Além
              de ser uma poderosa ferramenta para instrução, educação e reflexão
              humanas.
            </p>
          </div>
          <div className="col grid_6">
            <img src={ImgSessaoCinema} alt="Sessão de Cinema" />
          </div>
        </div>
      </section>

      <Galery galeryImgs={galeryImgs} />
    </div>
  );
};

export default SessaoCinema;
